import { useEffect, useState } from "react";
import { faqs } from "@/mocks/observeData";
import Header from "./components/Header";
import Hero from "./components/Hero";
import TopicSection from "./components/TopicSection";
import LatestSection from "./components/LatestSection";
import CategorySection from "./components/CategorySection";
import ReportSection from "./components/ReportSection";
import GuideSection from "./components/GuideSection";
import FaqSection from "./components/FaqSection";
import AboutSection from "./components/AboutSection";
import ContactSection from "./components/ContactSection";
import Footer from "./components/Footer";

function upsertMeta(attr: "name" | "property", key: string, content: string) {
  let el = document.head.querySelector<HTMLMetaElement>(`meta[${attr}="${key}"]`);
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function injectJsonLd(obj: Record<string, unknown>) {
  const id = `ld-${obj["@type"]}`;
  document.getElementById(id)?.remove();
  const script = document.createElement("script");
  script.type = "application/ld+json";
  script.id = id;
  script.text = JSON.stringify(obj);
  document.head.appendChild(script);
}

export default function Home() {
  const [showTop, setShowTop] = useState(false);

  useEffect(() => {
    document.title = "99黑料 - 企业品牌舆情观察与消费避坑资讯";
    upsertMeta("name", "description", "99黑料专注企业品牌舆情观察与消费避坑，汇集公司黑料、品牌争议、产品与服务问题追踪，坚持可溯源、重核实，持续更新热门公司丑闻与产品翻车议题。");
    upsertMeta("name", "keywords", "99黑料,企业黑料,公司黑料,品牌黑料,产品黑料,服务黑料,舆情观察,消费避坑");
    upsertMeta("property", "og:title", "99黑料 - 企业品牌舆情观察与消费避坑资讯");
    upsertMeta("property", "og:description", "99黑料专注企业品牌舆情观察与消费避坑，坚持可溯源、重核实，持续更新热门公司丑闻与产品翻车议题。");

    const faqLd = {
      "@context": "https://schema.org",
      "@type": "FAQPage",
      mainEntity: faqs.map((f) => ({
        "@type": "Question",
        name: f.q,
        acceptedAnswer: { "@type": "Answer", text: f.a },
      })),
    };
    injectJsonLd(faqLd);
    injectJsonLd({
      "@context": "https://schema.org",
      "@type": "Organization",
      name: "99黑料",
      description: "企业品牌舆情观察与消费避坑资讯站",
    });
    injectJsonLd({
      "@context": "https://schema.org",
      "@type": "WebSite",
      name: "99黑料",
      description: "企业品牌舆情观察与消费避坑资讯站",
      inLanguage: "zh-CN",
    });

    const onScroll = () => setShowTop(window.scrollY > 600);
    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <div className="min-h-screen bg-background-50 font-body text-foreground-950">
      <Header />
      <main>
        <Hero />
        <TopicSection />
        <LatestSection />
        <CategorySection />
        <ReportSection />
        <GuideSection />
        <FaqSection />
        <AboutSection />
        <ContactSection />
      </main>
      <Footer />

      {showTop && (
        <a
          href="#top"
          aria-label="返回顶部"
          className="fixed bottom-6 right-6 z-40 flex h-11 w-11 cursor-pointer items-center justify-center rounded-full bg-primary-500 text-background-50 transition-colors hover:bg-primary-600"
        >
          <i className="ri-arrow-up-line text-xl" />
        </a>
      )}
    </div>
  );
}